import { render, staticRenderFns } from "./footerComponent.vue?vue&type=template&id=22c7c2cb&scoped=true&"
import script from "./footerComponent.vue?vue&type=script&lang=js&"
export * from "./footerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c7c2cb",
  null
  
)

export default component.exports